import { post, get, getCookie, api_token, token, DEV_TOKEN } from './api.js';
import { writable } from 'svelte/store';

export const userLogin = writable("");
export const lastWedding = writable("");

let userRequest = null;

export function getUser() {
	if (userRequest == null) {
		userRequest = writable(loadUser());
	}
	return userRequest;
}

function loadUser() {
	return post('auth/current', null, token)
		.then(r => {
			api_token.set(r.token);
			userLogin.set(r.login);
			lastWedding.set(r.wedding_id);

			if (r.id > 0) {
				return get(`users/${r.id}`, r.token);
			} else {
				//console.log(r);
				return Promise.reject(new Error("anonymous"));
			}
		}, e => {
			api_token.set(e.token);
			if (e.login !== undefined) {
				userLogin.set(e.login);
			} else {
				userLogin.set("");
			}
			throw e;
		});
}

/*
 * Chargement du user => on lance le check des le chargement du module.
 */
export function load() {
	userRequest.update(() => loadUser());
}

/**
 * Login.
 */
export async function login(email, password) {

	let result = post('auth/', { user: { email: email, password: password } })
		.then(r => {
			api_token.set(r.token);
			lastWedding.set(r.wedding_id);
			return get(`users/${r.id}`, r.token);
		});

	userRequest.set(result);
	return result;
}

/**
 * Logout.
 */
export async function logout() {
	await post('auth/logout');
	api_token.set(undefined);
	await load();
}

/**
 * Create User.
 */
export function create(email, password, nickname, code) {
	return post('users/', { login: email, password: password, nickname: nickname, code: code }, token || DEV_TOKEN);
}

/**
 * Verify User.
 */
export function verify(action, code) {
	return post('verify/', { action: action, code: code }, token || DEV_TOKEN);
}

/**
 * Check login.
 */
export function uniqueLogin(login) {
	return post(`user_check/login`, { data: login }, token || DEV_TOKEN);
}

/**
 * Check pseudo.
 */
export function uniqueNickname(nickname) {
	return post(`user_check/nickname`, { data: nickname }, token || DEV_TOKEN);
}

/**
 * Lost password.
 * 
 * @param {*} email 
 * @param {*} action 
 * @param {*} code 
 */
export function lostPassword(email, action, code, password) {
	return post(`lost_pwd/${email}`, { action: action, code: code, password: password }, token || DEV_TOKEN);
}

export function getUsers(wedding_id) {
	return get(`users/?wedding_id=${wedding_id}`, token || DEV_TOKEN);
}
